import React, { useEffect, useState } from "react";
import { PageTitle } from "../PageTitle";
import i18next from "i18next";
import { OpSenseToastContainer, toast } from "../Toast";
import { Redirect } from "react-router-dom";
import { EventConfigurationsService } from "../../services";
import EventWorkflowConfigurationForm from "./event_workflow_configuration_form";

const EventWorkflowConfigurationEdit = ({ match, location }) => {
    const [loading, setLoading] = useState(false);
    const [originalWorkflowConfiguration, setOriginalWorkflowConfiguration] = useState(null);
    const [redirect, setRedirect] = useState(false);

    useEffect(() => {
        setLoading(true);

        EventConfigurationsService.getWorkflow(match.params.eventConfigurationId)
            .then(({workflowConfiguration}) => {
                setOriginalWorkflowConfiguration(workflowConfiguration);
                setLoading(false);
            }).catch((err) => {
                setLoading(false);
                console.error(err);
                toast.error("Error loading workflow configuration.");
            })
    }, [match]);

    const saveWorkflowConfiguration = (payload) => {
        toast.info("Saving", {autoClose: false});

        EventConfigurationsService
            .saveWorkflow(payload)
            .then((_) => {
                setRedirect(true);
            })
            .catch((err) => {
                console.error(err);
                toast.error("Error saving workflow.");
            });
    };

    const deleteWorkflowConfiguration = (configId) => {
        toast.info("Deleting", {autoClose: false});

        EventConfigurationsService
            .archiveWorkflow(configId)
            .then((_) => {
                setRedirect(true);
            })
            .catch((err) => {
                console.error(err);
                toast.dismiss();
                toast.error("Error deleting workflow.");
            });
    };

    return redirect ? (<Redirect to={{ pathname: '/config/events', state: { successMessage: i18next.t('messages.workflow-saved-success') }}} />) : (
        <div>
            <OpSenseToastContainer />

            <div className="row">
                <PageTitle 
                    title={i18next.t("pages.event-workflow-configurations.edit-header")} 
                    backLinkWithParams={{ link: { pathname: "/config/events", search: location?.state?.backLinkSearch } }} 
                />
            </div>

            { loading && <div className="loader">Loading...</div> }

            { originalWorkflowConfiguration &&
                <EventWorkflowConfigurationForm 
                    onSaveWorkflowConfiguration={saveWorkflowConfiguration} 
                    originalConfiguration={originalWorkflowConfiguration}
                    onDeleteWorkflowConfiguration={deleteWorkflowConfiguration}
                />
            }
        </div>
    );
};

export default EventWorkflowConfigurationEdit;
